

const tools = [
  { name: 'React', icon: 'react' },
  { name: 'Next.js', icon: 'nextdotjs' },
  { name: 'Tailwind CSS', icon: 'tailwindcss' },
  { name: 'TypeScript', icon: 'typescript' },
  { name: 'JavaScript', icon: 'javascript' },
  { name: 'Node.js', icon: 'nodedotjs' },
  { name: 'Express.js', icon: 'express' },
  { name: 'PHP', icon: 'php' },
  { name: 'Laravel', icon: 'laravel' },
  { name: 'WordPress', icon: 'wordpress' },
  { name: 'jQuery', icon: 'jquery' },
  { name: 'Bootstrap', icon: 'bootstrap' },
  { name: 'MySQL', icon: 'mysql' },
  { name: 'MongoDB', icon: 'mongodb' },
  { name: 'HTML5', icon: 'html5' },
  { name: 'Sass', icon: 'sass' },
  { name: 'Python', icon: 'python' },
  { name: 'Figma', icon: 'figma' },
];

const ToolSection = () => {
  return (
    <section className="bg-gray-950 text-white py-20 px-6">
      <div className="max-w-6xl mx-auto text-center space-y-10">
        <h2 className="text-3xl md:text-4xl font-bold">
          Tools, die wir verwenden
        </h2>
        <p className="text-gray-400 max-w-3xl mx-auto">
          In unserer täglichen Arbeit kombinieren wir bewährte Technologien mit modernen Frameworks – immer abgestimmt auf das, was dein Projekt wirklich braucht.
        </p>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-6 mt-12">
          {tools.map((tool, index) => (
            <div
              key={index}
              className="group bg-gray-800 rounded-xl h-20 flex items-center justify-center p-4 transition"
            >
              {/* Icon */}
              <img
                src={`https://cdn.simpleicons.org/${tool.icon}/ffffff`}
                alt={tool.name}
                className="h-10 w-10 group-hover:hidden block"
              />

              {/* Tool Name */}
              <span className="text-sm font-semibold text-white hidden group-hover:block">
                {tool.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolSection;
